import { Fragment } from 'react';
import PropTypes from 'prop-types';
import Styles from './CurveLineMaker.module.scss';

const CurveLineMaker = ({ sentence, underlineText: findText }) => {
  const parts = sentence.split(findText);
  return (
    <>
      {parts.map((v, idx) => (
        <Fragment key={idx}>
          {v}
          {idx !== parts.length - 1 && <span className={Styles.curveLine}>{findText}</span>}
        </Fragment>
      ))}
    </>
  );
};

CurveLineMaker.propTypes = {
  sentence: PropTypes.string,
  underlineText: PropTypes.string,
};

export default CurveLineMaker;
